/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "zsdxubiimrzikomntvtq"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzZHh1YmlpbXJ6aWtvbW50dnRxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1ODIzOTIsImV4cCI6MjA3MTE1ODM5Mn0.tWC3JqNQTaHS6FEHvELBnwpPKxuuR4HMMKXsryt63-c"